/**
 * ElevenLabs Intake Configuration
 * Priority order for enabling the feature:
 * 1) URL query param ?elevenlabs=1|true
 * 2) window.USE_ELEVENLABS_INTAKE (boolean) or localStorage.USE_ELEVENLABS_INTAKE ("true"/"false")
 * 3) process.env.REACT_APP_USE_ELEVENLABS_INTAKE === 'true'
 */
function readElevenLabsFlag() {
  try {
    // URL query param
    const qs = new URLSearchParams(window.location.search);
    const qsv = qs.get('elevenlabs');
    if (qsv && ['1', 'true', 'yes', 'on'].includes(qsv.toLowerCase())) return true;
    if (qsv && ['0', 'false', 'no', 'off'].includes(qsv.toLowerCase())) return false;

    // Global window override (runtime)
    if (typeof window !== 'undefined' && typeof window.USE_ELEVENLABS_INTAKE === 'boolean') {
      return window.USE_ELEVENLABS_INTAKE;
    }

    // LocalStorage
    if (typeof window !== 'undefined' && window.localStorage) {
      const ls = window.localStorage.getItem('USE_ELEVENLABS_INTAKE');
      if (ls === 'true') return true;
      if (ls === 'false') return false;
    }
  } catch (e) {
    // ignore
  }

  // .env (build-time)
  return process.env.REACT_APP_USE_ELEVENLABS_INTAKE === 'true';
}

// Configuration for intake interface selection
export const USE_ELEVENLABS_INTAKE = readElevenLabsFlag();

/**
 * Resolve agent ID and API key from multiple sources:
 * 1) window.ELEVENLABS_AGENT_ID / window.ELEVENLABS_API_KEY
 * 2) process.env.REACT_APP_ELEVENLABS_AGENT_ID / REACT_APP_ELEVENLABS_API_KEY
 * 3) Defaults
 */
function resolveAgentId() {
  try {
    if (typeof window !== 'undefined' && window.ELEVENLABS_AGENT_ID) {
      return window.ELEVENLABS_AGENT_ID;
    }
  } catch {}
  return process.env.REACT_APP_ELEVENLABS_AGENT_ID || 'MxvnsnriCpWRZSm1Pnou';
}

function resolveApiKey() {
  try {
    if (typeof window !== 'undefined' && window.ELEVENLABS_API_KEY) {
      return window.ELEVENLABS_API_KEY;
    }
  } catch {}
  return process.env.REACT_APP_ELEVENLABS_API_KEY || '';
}

// ElevenLabs configuration for widget-based approach
export const ELEVENLABS_CONFIG = {
  ENABLED: USE_ELEVENLABS_INTAKE,
  AGENT_ID: resolveAgentId(),
  API_KEY: resolveApiKey(),
  BASE_URL: 'https://api.elevenlabs.io/v1',
  WIDGET_SCRIPT_URL: 'https://unpkg.com/@elevenlabs/convai-widget-embed'
};

console.log('🎙️ ElevenLabs Intake Config:', {
  enabled: USE_ELEVENLABS_INTAKE,
  agentId: ELEVENLABS_CONFIG.AGENT_ID,
  hasApiKey: !!ELEVENLABS_CONFIG.API_KEY
});
